import React, { FC } from 'react'
import { Box, BoxProps } from '@popmenu/common-ui'

export const FullScreenStepperContent: FC<BoxProps & { name: string }> = (props) => {
  const { name: remove, ...boxProps } = props
  return (
    <Box py={8} {...boxProps}>
      {props.children}
    </Box>
  )
}
